import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A notification's link lands on a list with `?<param>=<id>` (e.g.
 * /wifi-partners?inquiry=…). Find the row marked `data-focus-id="<id>"`,
 * scroll it to the middle and flash it, so the operator sees WHICH row the
 * notification was about. Lists load async, so keep looking for ~6 s.
 */
export function useFocusFromQuery(param: string): string | null {
   const [params] = useSearchParams();
   const id = params.get(param);
   useEffect(() => {
      if (!id) return;
      let tries = 0;
      const timer = window.setInterval(() => {
         const el = document.querySelector<HTMLElement>(`[data-focus-id="${CSS.escape(id)}"]`);
         if (el) {
            window.clearInterval(timer);
            el.scrollIntoView({ block: 'center', behavior: 'smooth' });
            el.classList.add('focus-flash');
            window.setTimeout(() => el.classList.remove('focus-flash'), 2600);
         } else if (++tries > 40) {
            window.clearInterval(timer);
         }
      }, 150);
      return () => window.clearInterval(timer);
   }, [id]);
   return id;
}
